import React from 'react';
import classNames from 'classnames';
import cls from './ModalBodyTableRegistry.module.css';
import { useModalBodyTableRegistry } from './useModalBodyTableRegistry';
import { TableHeaderRegistry } from '../../../../Blocks/FinancialIndicatorsBlock/UI/TableFinancialIndicators/UI/TableHeaderRegistry/TableHeaderRegistry';
import { TableRowRegistry } from '../../../../Blocks/FinancialIndicatorsBlock/UI/TableFinancialIndicators/UI/TableRowRegistry/TableRowRegistry';
import { RegistryInformation } from '../useModalBodyReconciliationOfCalculations';
import moment from 'moment';

interface ModalBodyTableRegistryProps {
    classes?: string;
    paymentsInformation: RegistryInformation;
}

export const ModalBodyTableRegistry = ({
    classes,
    paymentsInformation,
}: ModalBodyTableRegistryProps) => {
    return (
        <div className={classNames(cls.ModalBodyTableRegistry, [classes])}>
            <span className={cls.Title}>{i18next.t('ModalBodyTableRegistry.result.title')}</span>
            {paymentsInformation.estimates.length > 0 && paymentsInformation.total.length > 0 ? (
                <>
                    <TableHeaderRegistry />
                    {paymentsInformation.estimates.map((estimate, index) => (
                        <TableRowRegistry
                            key={index}
                            date={moment(estimate.created_at)
                                .locale(LOCALE)
                                .format(i18next.t('ModalBodyTableRegistry.result.format'))}
                            estimateTitle={estimate.estimate_name}
                            //@ts-ignore
                            sum={numberFormatter.formatNumber(estimate.sum)}
                            currencyCode={estimate.currency_short_code}
                            comment={estimate.comment}
                        />
                    ))}
                    {paymentsInformation.total.map((estimate, index) => (
                        <TableRowRegistry
                            key={index}
                            date={null}
                            estimateTitle={null}
                            //@ts-ignore
                            sum={numberFormatter.formatNumber(estimate.sum)}
                            currencyCode={estimate.currency_short_code}
                            comment={null}
                            isFooter={true}
                        />
                    ))}
                </>
            ) : (
                <div className={cls.PaymentsEmptyText}>
                    {i18next.t('ModalBodyTableRegistry.result.PaymentsEmptyText')}
                </div>
            )}
        </div>
    );
};
